import { render } from "./Highlight.vue?vue&type=template&id=4fb693ae&scoped=true"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import "./Highlight.vue?vue&type=style&index=0&id=4fb693ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Riccardo\\Desktop\\vue-app\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb693ae"]])

export default __exports__